import localforage from "localforage";

export function createLocalStore<T>(dbName: string, storeName: string) {
  const store = localforage.createInstance({
    name: dbName,
    storeName: storeName,
  });

  return {
    async set(id: string, value: T) {
      return store.setItem<T>(id, value);
    },

    async get(id: string): Promise<T | null> {
      return store.getItem<T>(id);
    },

    async remove(id: string) {
      return store.removeItem(id);
    },

    async getAll(): Promise<T[]> {
      const items: T[] = [];
      await store.iterate((value: T) => {
        items.push(value);
      });
      return items;
    },

    async clear() {
      return store.clear();
    },
  };
}
